// import { commomState_LoggedinInfo } from './../store/common/common.selectors';
import { AppState } from './../store/app.states';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { of, Observable } from 'rxjs';
import { insuranceQuestionnaire_ShowQuestionnaire } from '../modules/shared/components/insurance-questionnaire/selectors';

@Injectable()
export class ShowQuestionnaireGuardService implements CanActivate {

  showQuestionnaire$ = this.store.pipe(select(insuranceQuestionnaire_ShowQuestionnaire));

  constructor(public store: Store<AppState>,
    private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Observable<boolean>(obs => {
      this.showQuestionnaire$.subscribe(showQuestionnaire => {

        if (showQuestionnaire) {
          obs.next(true);
        }

        obs.next(false);
      })
    });
  }
}
